import React from "react";

export const Container = ({ children }) => {
  return (
    <div className="w-full flex justify-center">
      <div className="max-w-6xl p-4 py-8 w-full z-10">{children}</div>
    </div>
  );
};
